import React, { useEffect, useState } from 'react';
import { baseUrl } from '../../shared/baseUrl';
import TopSellerShimmer from './TopSellerShimmer';

const TopSeller = () => {
  const [topSeller, setTopSeller] = useState([]);
  const [isLoading, setIsLoading] = useState(true)
  // const [isLogin, setIsLogin] = useState(true)
  // const [scrollPosition, setScrollPosition] = useState(0);
  const [numSellersToShow, setNumSellersToShow] = useState(
    window.innerWidth < 992 ? 5 : 10
  );

  const fetchTopSeller = async () => {
    try {
      const res = await fetch(`${baseUrl}top-sellers`);
      const data = await res.json();
      setIsLoading(false)
      setTopSeller(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchTopSeller();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      // Update the number of sellers based on window width
      setNumSellersToShow(window.innerWidth < 992 ? 5 : 10);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // const numSellersToShow = window.innerWidth < 992 ? 5 : topSeller.length;
  // console.log(numSellersToShow)

  return (
    <>
      {isLoading ? (
        <>
          <div className='d-flex gap-1 justify-content-around '>
            {Array(numSellersToShow)
              .fill()
              .map((_, index) => {
                return (
                  <TopSellerShimmer key={index} index={index}
                  />
                );
              })}
          </div>
        </>
      ) :
        (
          <div className='sellercard d-flex justify-content-around align-items-start gap-1'>

            {topSeller.slice(0, numSellersToShow).map((seller, _) => {
              return (
                <div key={seller.id} className='fcard cursor-pointer d-flex flex-column align-items-center' style={{ width: '120px' }} onClick={() => { window.location.href = `/products/userallproducts/${seller.name}/${seller.id}` }}>
                  <img
                    onError={(e) => {
                      e.target.src = "https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=" +
                        seller.name
                    }}
                    src={
                      seller.avatar ??
                      "https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=" +
                      seller.name
                    }
                    width="50"
                    height="50"
                    alt={seller.name}
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                  />
                  <p className='sname cursor-pointer fw-semibold text-center' style={{ fontSize: '16px', marginTop: '4px' }}>{seller.name}</p>
                </div>
              )
            })}
          </div>
        )
      }
    </>
  )
}

export default TopSeller




